import {
  OrganizationIcon,
  PersonIcon,
  ProductIcon,
  ThemeIcon,
  PriceListIcon,
  NoteIcon,
  OrderIcon,
  DeliveryIcon,
  ReceiptEuroIcon,
  ReceiptRefundIcon,
  OrderRepeatIcon,
  EmailIcon,
  CartIcon,
  ReceiptIcon,
  SettingsIcon,
  ContractIcon,
  WrenchIcon,
  ClipboardChecklistIcon,
  ChatIcon,
  TeamIcon,
  FileIcon,
  TextBlockIcon,
  NoteAddIcon
} from '@shopify/polaris-icons';

/*
  Result types of the global search (server/services/search). family drives the icon colour, scope the filter pill
  that shows the type. A type the server sends but this list misses still renders with the file icon.
*/
export const SEARCH_TYPES = {
  company: { label: 'Company', icon: OrganizationIcon, family: 'crm', scope: 'crm' },
  contact: { label: 'Contact', icon: PersonIcon, family: 'crm', scope: 'crm' },
  interaction: { label: 'Interaction', icon: ChatIcon, family: 'crm', scope: 'crm' },
  employee: { label: 'Employee', icon: TeamIcon, family: 'crm', scope: 'crm' },
  product: { label: 'Product', icon: ProductIcon, family: 'catalog', scope: 'products' },
  project: { label: 'Project', icon: ThemeIcon, family: 'project', scope: 'projects' },
  project_quotation: { label: 'Quotation builder', icon: PriceListIcon, family: 'project', scope: 'projects' },
  quotation: { label: 'Quotation', icon: NoteIcon, family: 'sales', scope: 'sales' },
  sales_order: { label: 'Sales order', icon: OrderIcon, family: 'sales', scope: 'sales' },
  delivery_note: { label: 'Delivery note', icon: DeliveryIcon, family: 'sales', scope: 'sales' },
  invoice: { label: 'Invoice', icon: ReceiptEuroIcon, family: 'sales', scope: 'sales' },
  credit_note: { label: 'Credit note', icon: ReceiptRefundIcon, family: 'sales', scope: 'sales' },
  recurring_invoice: { label: 'Recurring invoice', icon: OrderRepeatIcon, family: 'sales', scope: 'sales' },
  inquiry: { label: 'Inquiry', icon: EmailIcon, family: 'purchasing', scope: 'purchasing' },
  purchase_order: { label: 'Purchase order', icon: CartIcon, family: 'purchasing', scope: 'purchasing' },
  invoice_in: { label: 'Invoice IN', icon: ReceiptIcon, family: 'purchasing', scope: 'purchasing' },
  credit_note_in: { label: 'Credit note IN', icon: ReceiptRefundIcon, family: 'purchasing', scope: 'purchasing' },
  machine: { label: 'Machine', icon: SettingsIcon, family: 'service', scope: 'service' },
  maintenance_contract: { label: 'Maintenance contract', icon: ContractIcon, family: 'service', scope: 'service' },
  job: { label: 'Job', icon: WrenchIcon, family: 'service', scope: 'service' },
  montage_bon: { label: 'Montage bon', icon: ClipboardChecklistIcon, family: 'service', scope: 'service' },
  file: { label: 'File', icon: FileIcon, family: 'file', scope: 'files' }
};

// groups fed by several sources (server/services/search/providers/deep.js)
export const DEEP_GROUPS = {
  files: { label: 'Files', icon: FileIcon, family: 'file' },
  lines: { label: 'In document lines', icon: TextBlockIcon, family: 'deep' },
  notes: { label: 'In notes & descriptions', icon: NoteAddIcon, family: 'deep' }
};

export const typeInfo = (type) => SEARCH_TYPES[type] || { label: 'Result', icon: FileIcon, family: 'file', scope: 'all' };

/*
  Filter pills. types: what the server searches for the pill (provider keys / record types, see server KNOWN_TYPES);
  null = everything. commands: whether pages and actions are listed.
*/
export const SCOPES = [
  { key: 'all', label: 'All', types: null, commands: true },
  { key: 'crm', label: 'Companies & contacts', types: ['company', 'contact', 'interaction', 'employee'], commands: false },
  { key: 'products', label: 'Products', types: ['product'], commands: false },
  { key: 'sales', label: 'Sales', types: ['quotation', 'sales_order', 'delivery_note', 'invoice', 'credit_note', 'recurring_invoice'], commands: false },
  { key: 'purchasing', label: 'Purchasing', types: ['inquiry', 'purchase_order', 'invoice_in', 'credit_note_in'], commands: false },
  { key: 'projects', label: 'Projects', types: ['project', 'project_quotation'], commands: false },
  { key: 'service', label: 'Service', types: ['machine', 'maintenance_contract', 'job', 'montage_bon'], commands: false },
  { key: 'files', label: 'Files', types: ['files'], commands: false },
  { key: 'commands', label: 'Pages & actions', types: [], commands: true }
];

export const scopeByKey = (key) => SCOPES.find((scope) => scope.key === key) || SCOPES[0];

// label of a group header (server groups carry their own label; deep groups are known here)
export const groupLabel = (group) => DEEP_GROUPS[group.key]?.label || group.label || typeInfo(group.key).label;
